import React from "react"
import { useSelector } from "react-redux"
import { Box, CircularProgress } from "@mui/material"

import { RootState } from "../../../store/store"
import {
  Amount,
  ContentContainer,
  DetailContainer,
  DetailLabel,
  DetailsContainer,
  DetailValue,
  StyledButton,
  StyledDivider,
  TopContainer,
} from "./styled"
import IconBox from "../../../components/IconBox"
import UIIcon from "../../../components/UIIcon"
import { formatAmount, formatPhoneNumber } from "../../../utils/formatters"
import { ConfirmSbpOutcomeTransferProps } from "./props"
import { RUBLE } from "../../../utils/constants"
import { LoadingWindow } from "../../styled"

const ConfirmSbpOutcomeTransfer = ({
  pam,
  commissionAmount,
  isLoading,
  handleConfirm,
}: ConfirmSbpOutcomeTransferProps) => {
  const transferForm = useSelector((state: RootState) => state.transferForm)

  return (
    <ContentContainer>
      {isLoading && (
        <LoadingWindow>
          <CircularProgress />
        </LoadingWindow>
      )}
      <TopContainer>
        <IconBox size="lg">
          <UIIcon iconName="sbpIcon" size={70} />
        </IconBox>
        <Amount>{formatAmount(transferForm.amount.value)} {RUBLE}</Amount>
      </TopContainer>
      <StyledDivider />
      <DetailsContainer>
        <DetailContainer>
          <DetailLabel>Номер телефона получателя</DetailLabel>
          <DetailValue>{transferForm.recipient ? formatPhoneNumber(transferForm.recipient?.phone) : ""}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>ФИО получателя</DetailLabel>
          <DetailValue>{pam}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Банк получателя</DetailLabel>
          <DetailValue>{transferForm.selectedBank?.title}</DetailValue>
        </DetailContainer>
        <DetailContainer>
          <DetailLabel>Сумма перевода</DetailLabel>
          <DetailValue>{formatAmount(transferForm.amount.value)} {RUBLE}</DetailValue>
        </DetailContainer>
        {commissionAmount ? (
          <DetailContainer>
            <DetailLabel>Комиссия</DetailLabel>
            <DetailValue>{formatAmount(commissionAmount)} {RUBLE}</DetailValue>
          </DetailContainer>
        ) : (
          <DetailContainer>
            <DetailValue>Комиссия не взимается</DetailValue>
          </DetailContainer>
        )}
      </DetailsContainer>
      <Box sx={{ marginTop: "auto" }}>
        <StyledButton
          fullWidth
          variant="contained"
          disabled={isLoading}
          onClick={handleConfirm}
        >
          Перевести
        </StyledButton>
      </Box>
    </ContentContainer>
  )
}

export default ConfirmSbpOutcomeTransfer
